module.exports = __webpack_public_path__ + "static/assets/8b7e3e7284a8deeb4fe41a9f95bcdc7b.svg";